import React, { useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import logo from 'assets/images/logo.jpg';
import { isIE } from '../../utils/tools';
import axios from 'axios';

import NotificationPopOver from '../../components/UI/Notifications/NotificationPopOver';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ToastifyNotification from 'components/UI/Notifications/ToastifyNotification';

import { Card } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import './EmptyLayout.scss';

/**
 *@returns JSX
 */
const EmptyLayout = ({ component: Component, ...rest }) => {
  const [versionNumber, setVersionNumber] = useState('0.0.0');
  //notify the master template to the page type
  document.body.classList.toggle('account-pages', true);
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  useEffect(() => {
    async function fetchVersion() {
      await axios.get(`/api_v2/options/version`).then((res) => {
        const v = res.data.option;
        if (v) {
          setVersionNumber(v);
        }
      });
    }
    fetchVersion();
  }, []);

  return (
    <div className="page-wrap">
      {isIE && (
        <div className="notification-popover">
          <NotificationPopOver
            title={
              <>
                <i className="mdi mdi-alert" /> Unsupported Browser
              </>
            }
            message="The version of Internet Explorer you are using is not supported by Life Skills GO. We recommend using Chrome or any modern internet browser."
            childrenElement={
              <>
                <a
                  className="btn btn-danger"
                  target="_blank"
                  href="https://www.microsoft.com/en-au/microsoft-365/windows/end-of-ie-support"
                  rel="noopener noreferrer"
                >
                  More information
                </a>
              </>
            }
            alertStyle="danger"
            alertWidth={500}
          />
        </div>
      )}
      <div className="lsgo-empty-layout container-fluid">
        <div className="empty-component-holder">
          <Card className="component-card">
            <h2 className="text-uppercase text-center">
              <a href="/" className="text-success">
                <span>
                  <img className="lifeskills-logo" src={logo} alt="" />
                </span>
              </a>
            </h2>
            <Route {...rest} render={(props) => <Component {...props} />} />
          </Card>
        </div>
      </div>
      <div>
        <ToastifyNotification />
        <ToastContainer toastClassName="server-notification" autoClose={false} closeOnClick={false} />
      </div>
      <div className="row text-center empty-footer">
        <div id="versionNumber" className="col-sm-12">
          <a
            href="https://help.lifeskillsgroup.com.au/life-skills-go-change-list"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'block' }}
          >
            <span>Version: v{versionNumber}</span>
          </a>
          <span style={{ display: 'block' }}>{currentYear} &copy; Life Skills Group Online Pty Ltd.</span>
        </div>
      </div>
    </div>
  );
};

EmptyLayout.propTypes = {
  component: PropTypes.func.isRequired,
};

export default EmptyLayout;
